const ebidtaAmountRanges = [
  {
    title: 'No tiene',
    id: 'EAR00',
    index: 0,
    color: '#f30',
    rouletteHidden: true,
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '0',
    id: 'EAR01',
    index: 1,
    color: '#f30',
    rouletteHidden: true,
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: 'Positivo',
    id: 'EAR16',
    index: 2,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '100000',
    id: 'EAR17',
    index: 3,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '250000',
    id: 'EAR18',
    index: 4,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '500000',
    id: 'EAR19',
    index: 5,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '1000000',
    id: 'EAR14',
    index: 6,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '2000000',
    id: 'EAR15',
    index: 7,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '3000000',
    id: 'EAR02',
    index: 8,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '6000000',
    id: 'EAR03',
    index: 9,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '9000000',
    id: 'EAR20',
    index: 10,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '12000000',
    id: 'EAR04',
    index: 11,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '15000000',
    id: 'EAR21',
    index: 12,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '20000000',
    id: 'EAR22',
    index: 13,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '25000000',
    id: 'EAR23',
    index: 14,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '30000000',
    id: 'EAR05',
    index: 15,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '40000000',
    id: 'EAR24',
    index: 16,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '50000000',
    id: 'EAR25',
    index: 17,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '60000000',
    id: 'EAR06',
    index: 18,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '80000000',
    id: 'EAR26',
    index: 19,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '100000000',
    id: 'EAR27',
    index: 20,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '120000000',
    id: 'EAR07',
    index: 21,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '250000000',
    id: 'EAR08',
    index: 22,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '500000000',
    id: 'EAR09',
    index: 23,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '1000000000',
    id: 'EAR10',
    index: 24,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '2000000000',
    id: 'EAR11',
    index: 25,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '5000000000',
    id: 'EAR12',
    index: 26,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  },
  {
    title: '10000000000',
    id: 'EAR13',
    index: 27,
    color: '#f30',
    colorFilterValues: {
      invert: '27',
      sepia: '34',
      saturate: '6630',
      hueRotate: '1',
      brightness: '102',
      contrast: '108'
    }
  }
]

export default ebidtaAmountRanges
